// extracted by mini-css-extract-plugin
export default {"fifth":"SmoothSlider_fifth__1-Xol","fifth1":"SmoothSlider_fifth1__qxL7H","fifth-1":"SmoothSlider_fifth-1__QB432","sticky":"SmoothSlider_sticky__oJ5S4"};